import { render, staticRenderFns } from "./CapacityComponent.vue?vue&type=template&id=29283928&scoped=true"
import script from "./CapacityComponent.vue?vue&type=script&lang=js"
export * from "./CapacityComponent.vue?vue&type=script&lang=js"
import style0 from "./CapacityComponent.vue?vue&type=style&index=0&id=29283928&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29283928",
  null
  
)

export default component.exports